import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=00b48d7d&scoped=true"
import script from "./Content.vue?vue&type=script&lang=ts"
export * from "./Content.vue?vue&type=script&lang=ts"
import style0 from "./Content.vue?vue&type=style&index=0&id=00b48d7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b48d7d",
  null
  
)

export default component.exports